/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import { Text } from 'hocs/localization'
import Modal, { ModalMessage, ModalFooter, ModalFooterButtons } from 'apps/Modal'
import Button from 'elements/Button'
import { getPrintedPostalCode } from 'utils/printedData'
import { MODAL_NAMES } from './constants'
import * as styles from './CorrectedAddressModal.scss'

interface IProps {
  t: Text,
  onCloseModal: () => void,
  accessToken: string,
  onConfirm: (params: any) => Promise<{}>,
  shippingMessage: any,
  billingMessage: any,
  shippingCorrectedResult: any,
  billingCorrectedResult: any,
  name: MODAL_NAMES,
}

interface IState {
  isSubmitting: boolean,
}

class CorrectedAddressModal extends React.Component<IProps, IState> {
  public readonly state = {
    isSubmitting: false,
  }

  private onSubmit = () => {
    this.setState({
      isSubmitting: true,
    })
    const { accessToken, shippingCorrectedResult, billingCorrectedResult } = this.props

    this.props.onConfirm({ accessToken, shippingCorrectedResult, billingCorrectedResult }).then(() => {
      this.props.onCloseModal()
    })
      .catch(() => {
        this.setState({
          isSubmitting: false,
        })
      })
  }

  public render () {
    const { t, shippingMessage, billingMessage, name } = this.props
    const { isSubmitting } = this.state

    return (
      <Modal name={name} header={t('pleaseNote')} hideCloseButton shouldCloseOnOverlayClick={false}>
        <ModalMessage>
          {[shippingMessage, billingMessage].map((form, i) => {
            if (form) {
              return t('message', {
                state: form.state,
                city: form.city,
                postalCode: getPrintedPostalCode(form.postalCode),
                address1: form.address1,
                formName: !i ? t('shipping') : t('billing'),
              })
            }
          })}
        </ModalMessage>
        <ModalFooter>
          <ModalFooterButtons>
            <div className={styles.buttonWrapper}>
              <Button fluid onClick={this.onSubmit} disabled={isSubmitting}>
                {isSubmitting ? t('okButtonSubmitting') : t('okButton')}
              </Button>
            </div>
          </ModalFooterButtons>
        </ModalFooter>
      </Modal>
    )
  }
}

export default CorrectedAddressModal
